import QuickMovementForm from "./QuickMovementForm";
export default function ExpenseForm() { return <QuickMovementForm type="expense" />; }
